// extracted by mini-css-extract-plugin
module.exports = {"errorCardContainer":"BpKH8Wm"};